import createReducer from "Common/reducerUtils/createReducer";
import listenerMiddleware from "App/listenerMiddleware";
import { getSummaryReportId } from "Areas/Sidebar/SummaryReports";
import set from "Common/reducerUtils/set";
import pick from "lodash/pick";
import { NAMESPACE } from "../constants";
import actionCreators from "./actionCreators";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { data: {} }
};
export default createReducer(initialState, {
    [actionTypes.SET_SUMMARY_REPORT_DATA]: (state, { data }) => set(state, `[${NAMESPACE}].data[${data.Id}]`, data),
    [actionTypes.CLEAR_DATA]: (state, { exceptSummaryReportId }) => exceptSummaryReportId
        ? {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                data: pick(state[NAMESPACE].data, exceptSummaryReportId)
            }
        }
        : {
            ...state,
            ...initialState
        }
});
listenerMiddleware.addListener({
    [actionTypes.GET_SUMMARY_REPORT_DETAILS_COMPLETED]: (action, dispatch, getState) => {
        const currentSummaryReportId = getSummaryReportId(getState());
        dispatch(actionCreators.clearData(currentSummaryReportId));
        if (currentSummaryReportId === action.payload.Id) {
            dispatch({
                type: actionTypes.SET_SUMMARY_REPORT_DATA,
                data: action.payload
            });
        }
    },
    [actionTypes.SAVE_SUMMARY_REPORT_DETAILS_COMPLETED]: (action, dispatch, getState) => {
        const currentSummaryReportId = getSummaryReportId(getState());
        dispatch(actionCreators.clearData(currentSummaryReportId));
        if (currentSummaryReportId === action.meta.data.Id) {
            dispatch({
                type: actionTypes.SET_SUMMARY_REPORT_DATA,
                data: action.meta.data
            });
        }
    }
});
